import { SET_LOADING, SET_ERROR, CLEAR_ERROR, TOGGLE_FEED_LIST_VIEW, TOGGLE_HOME_PAGE } from '../actions/common';

export default {
  state: {
    loading: false,
    error: null,
    listView: false,
    isHomePage: true,
  },
  getters: {
    loading: state => state.loading,
    error: state => state.error,
    listView: state => state.listView,
    isHomePage: state => state.isHomePage
  },
  actions: {
    [SET_LOADING]: ({commit}, payload) => {
      commit(SET_LOADING, payload);
    },
    [SET_ERROR]: ({commit}, payload) => {
      commit(SET_ERROR, payload);
    },
    [CLEAR_ERROR]: ({commit}) => {
      commit(CLEAR_ERROR);
    },
    [TOGGLE_FEED_LIST_VIEW]: ({commit}) => {
      commit(TOGGLE_FEED_LIST_VIEW);
    },
    [TOGGLE_HOME_PAGE]: ({commit}, payload) => {
      commit(TOGGLE_HOME_PAGE, payload);
    },
  },
  mutations: {
    [SET_LOADING]: (state, payload) => {
      state.loading = payload;
    },
    [SET_ERROR]: (state, payload) => {
      state.error = payload;
    },
    [CLEAR_ERROR]: state => {
      state.error = null;
    },
    [TOGGLE_FEED_LIST_VIEW]: state => {
      state.listView = !state.listView;
    },
    [TOGGLE_HOME_PAGE]: (state, payload) => {
      state.isHomePage = payload;
    }
  }
}
